import { Localization } from "@viamap/viamap2-common";
import { SelectLayer } from "src/components/CommonInputs";
import { GlassInputControl } from "src/components/GlassInput";
import { AreaUnit, AverageCalculationMethod } from "src/modules/JPBModule/JPBState";

type JPBSkovDemoSearchAreaProps = {
  selectableLayers: any[];
  selectedLayerId?: number;
  bufferDistanceKm: number;
  areaUnit: AreaUnit;
  averageCalculationMethod: AverageCalculationMethod;
  onLayerChange: (layerId?: number) => void;
  onBufferDistanceChange: (distanceKm: number) => void;
  onAreaUnitChange: (unit: AreaUnit) => void;
  onAverageCalculationMethodChange: (method: AverageCalculationMethod) => void;
};

export function JPBSkovDemoSearchArea(props: JPBSkovDemoSearchAreaProps) {
  return (
    <div className="jpb-search-area-layout">
      <div className="jpb-search-area-row">
        <div className="jpb-search-area-left">
          <div className="jpb-choice-stack">
            <div className="jpb-main-controls-select">
              <GlassInputControl>
                <select
                  value={props.areaUnit}
                  onChange={(event) =>
                    props.onAreaUnitChange(event.target.value as AreaUnit)
                  }
                >
                  <option value={AreaUnit.SquareMeter}>m²</option>
                  <option value={AreaUnit.Hectare}>ha</option>
                </select>
              </GlassInputControl>
            </div>
            <div className="jpb-main-controls-select">
              <GlassInputControl>
                <select
                  value={props.averageCalculationMethod}
                  onChange={(event) =>
                    props.onAverageCalculationMethodChange(
                      event.target.value as AverageCalculationMethod,
                    )
                  }
                >
                  <option value={AverageCalculationMethod.WeightedByArea}>
                    {Localization.getText("Weighted by area")}
                  </option>
                  <option value={AverageCalculationMethod.EqualPerSample}>
                    {Localization.getText("Equal per transaction")}
                  </option>
                </select>
              </GlassInputControl>
            </div>
          </div>
        </div>

        <div className="jpb-search-area-inputs">
          <div className="jpb-main-controls-split">
            <div className="jpb-main-controls-half jpb-main-controls-half--left">
              <div className="jpb-search-area-select jpb-main-controls-select">
                <SelectLayer
                  selectedLayerId={props.selectedLayerId || ""}
                  onSelect={(layerId) => props.onLayerChange(layerId)}
                  availableLayers={props.selectableLayers}
                />
              </div>
            </div>
            <div className="jpb-main-controls-half jpb-main-controls-half--right">
              <div className="jpb-search-area-select jpb-main-controls-select">
                <GlassInputControl>
                  <input
                    type="number"
                    min="0"
                    step="1"
                    value={props.bufferDistanceKm}
                    onChange={(event) => {
                      const nextValue = Number(event.target.value);
                      props.onBufferDistanceChange(
                        Number.isFinite(nextValue) && nextValue >= 0
                          ? nextValue
                          : 0,
                      );
                    }}
                  />
                  <span>{Localization.getText("Km")}</span>
                </GlassInputControl>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
